module.exports = __webpack_public_path__ + "static/media/location-c5002a.62e3ac96.svg";